import ModuleWrapper from '@/components/page/ModuleWrapper';

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard');
const meta = (data = {}) => ({
    moduleName: 'dashboard',
    auth: true,
    ...data,
});

export default [{
    path: 'dashboard',
    component: ModuleWrapper,
    meta: meta({
        title: 'Dashboard',
    }),
    children: [
        {
            path: '',
            name: 'Dashboard',
            component: Dashboard,
            meta: meta({}),
        },
    ],
}];
